<div class="row" *ngIf="isComercial">
    <div class="col-md col-xs col-xl col-sm wd-100-pc">
        <mat-card class="mat-elevation-z8 wd-100-pc">
            <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
                <div class="row">
                    <div class="col-md col-xs col-xl col-sm">
                        <p class="tituloLeft">{{step}}</p>
                    </div>
                    <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
                        <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
                            *ngIf="!collapseCard"></i>
                        <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
                            *ngIf="collapseCard"></i>
                    </div>
                </div>
                <mat-card-content *ngIf="!collapseCard">

                    <div class="row pt-3">
                        <div class="col-md">
                            <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Quebradas Leves (g)</mat-label>
                                <input matInput id="txtQuebradas" #txtQuebradas maxlength="10"
                                    formControlName="quebradas_g" currencyMask (blur)="makeCalculations()"
                                    [options]="{ thousands: '.', decimal: ',', precision: 1 }">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                                </mat-hint>
                                <mat-hint align="end">{{txtQuebradas.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.quebradas_g)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md">
                            <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Quebradas Severas (g)</mat-label>
                                <input matInput id="txtQuebradasSeveras" #txtQuebradasSeveras maxlength="10"
                                    formControlName="quebradas_severas_g" currencyMask (blur)="makeCalculations()"
                                    [options]="{ thousands: '.', decimal: ',', precision: 1 }">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                                </mat-hint>
                                <mat-hint align="end">{{txtQuebradasSeveras.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.quebradas_severas_g)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md">
                            <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Ardidas Leves (g)</mat-label>
                                <input matInput id="txtArdidasLeves" #txtArdidasLeves maxlength="10"
                                    formControlName="ardidas_g" currencyMask (blur)="makeCalculations()"
                                    [options]="{ thousands: '.', decimal: ',', precision: 1 }">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                                </mat-hint>
                                <mat-hint align="end">{{txtArdidasLeves.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.ardidas_g)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md">
                            <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Ardidas Severas (g)</mat-label>
                                <input matInput id="txtArdidasSeveras" #txtArdidasSeveras maxlength="10"
                                    formControlName="ardidas_severas_g" currencyMask (blur)="makeCalculations()"
                                    [options]="{ thousands: '.', decimal: ',', precision: 1 }">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                                </mat-hint>
                                <mat-hint align="end">{{txtArdidasSeveras.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.ardidas_severas_g)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-md">
                            <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Furadas Leves (g)</mat-label>
                                <input matInput id="txtFurLeves" #txtFurLeves maxlength="10"
                                    formControlName="furadas_leves_g" currencyMask (blur)="makeCalculations()"
                                    [options]="{ thousands: '.', decimal: ',', precision: 1 }">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                                </mat-hint>
                                <mat-hint align="end">{{txtFurLeves.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.furadas_leves_g)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md">
                            <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Furadas Severas (g)</mat-label>
                                <input matInput id="txtFurSeveras" #txtFurSeveras maxlength="10"
                                    formControlName="furadas_severas_g" currencyMask (blur)="makeCalculations()"
                                    [options]="{ thousands: '.', decimal: ',', precision: 1 }">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                                </mat-hint>
                                <mat-hint align="end">{{txtFurSeveras.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.furadas_severas_g)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-md">
                            <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Popped Kernel Leves (g)</mat-label>
                                <input matInput id="txtPopped" #txtPopped maxlength="10"
                                    formControlName="popped_kernel_g" currencyMask (blur)="makeCalculations()"
                                    [options]="{ thousands: '.', decimal: ',', precision: 1 }">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                                </mat-hint>
                                <mat-hint align="end">{{txtPopped.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.popped_kernel_g)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md">
                            <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Popped Kernel Severas (g)</mat-label>
                                <input matInput id="txtPoppedSeveras" #txtPoppedSeveras maxlength="10"
                                    formControlName="popped_kernel_severas_g" currencyMask (blur)="makeCalculations()"
                                    [options]="{ thousands: '.', decimal: ',', precision: 1 }">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                                </mat-hint>
                                <mat-hint align="end">{{txtPoppedSeveras.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.popped_kernel_severas_g)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md">
                            <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Inerte (g)</mat-label>
                                <input matInput id="txtInerte" #txtInerte maxlength="10" formControlName="inerte_g"
                                    currencyMask (blur)="makeCalculations()"
                                    [options]="{ thousands: '.', decimal: ',', precision: 1 }">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                                </mat-hint>
                                <mat-hint align="end">{{txtInerte.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.inerte_g)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md">
                            <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Presença de Sabugo ou Pedúnculo</mat-label>
                                <mat-select #txtPreSabPed formControlName="presenca_sabugo_ou_pedunculo"
                                    disableCenteringOption>
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterPreSabPed($event.target.value)">
                                    <mat-option *ngFor="let item of listPreSabPed" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.presenca_sabugo_ou_pedunculo)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-md">
                            <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Presença de Outras Sementes (Espécies)</mat-label>
                                <mat-select #txtPreOutSem formControlName="presenca_outras_sementes_especies"
                                    disableCenteringOption>
                                    <input matInput required ="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterPreSem($event.target.value)">
                                    <mat-option *ngFor="let item of listPreSem" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-error>
                                    {{hasErrorFormControl(formulario.controls.presenca_outras_sementes_especies)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md">
                            <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Total Defeitos (g)</mat-label>
                                <input matInput id="txtDef" #txtDef maxlength="10" formControlName="total_defeitos_prc"
                                    currencyMask readonly class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}
                                </mat-hint>
                                <mat-hint align="end">{{txtDef.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.total_defeitos_prc)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md">
                            <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Total Defeitos Leves(g)</mat-label>
                                <input matInput id="txtDef" #txtDef maxlength="10"
                                    formControlName="total_defeitos_leves_prc" currencyMask readonly
                                    class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}
                                </mat-hint>
                                <mat-hint align="end">{{txtDef.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.total_defeitos_leves_prc)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md">
                            <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Total Defeitos Severos(g)</mat-label>
                                <input matInput id="txtDef" #txtDef maxlength="10"
                                    formControlName="total_defeitos_severos_prc" currencyMask readonly
                                    class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}
                                </mat-hint>
                                <mat-hint align="end">{{txtDef.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.total_defeitos_severos_prc)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-md">
                            <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Resultado Descriminado - Caso Reprovado</mat-label>
                                <input matInput id="txtResDescr" #txtResDescr maxlength="500"
                                    formControlName="resultado_descriminado_caso_reprovado" readonly
                                    class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}
                                </mat-hint>
                                <mat-hint align="end">{{txtResDescr.value.length}} / 500</mat-hint>
                                <mat-error>
                                    {{hasErrorFormControl(formulario.controls.resultado_descriminado_caso_reprovado)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md">
                            <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Resultado</mat-label>
                                <input matInput id="txtRes" #txtRes maxlength="3" formControlName="resultado" readonly
                                    [ngStyle]="{'background-color': formulario.controls.resultado.value ==='APR' ? 'green' : 'red'  } ">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}
                                </mat-hint>
                                <mat-hint align="end">{{txtRes.value.length}} / 3</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.resultado)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                </mat-card-content>
            </form>
        </mat-card>
    </div>
</div>
<div class="row" *ngIf="isBasica">
    <div class="col-md col-xs col-xl col-sm wd-100-pc">
        <mat-card class="mat-elevation-z8 wd-100-pc">
            <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
                <div class="row">
                    <div class="col-md col-xs col-xl col-sm">
                        <p class="tituloLeft">{{step}}</p>
                    </div>
                    <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
                        <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
                            *ngIf="!collapseCard"></i>
                        <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
                            *ngIf="collapseCard"></i>
                    </div>
                </div>
                <mat-card-content *ngIf="!collapseCard">

                    <div class="row pt-3">
                        <div class="col-md">
                            <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Quebradas Leves (g)</mat-label>
                                <input matInput id="txtQuebradas" #txtQuebradas maxlength="10"
                                    formControlName="quebradas_g" currencyMask (blur)="makeCalculations()"
                                    [options]="{ thousands: '.', decimal: ',', precision: 1 }">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                                </mat-hint>
                                <mat-hint align="end">{{txtQuebradas.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.quebradas_g)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md">
                            <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Quebradas Severas (g)</mat-label>
                                <input matInput id="txtQuebradasSeveras" #txtQuebradasSeveras maxlength="10"
                                    formControlName="quebradas_severas_g" currencyMask (blur)="makeCalculations()"
                                    [options]="{ thousands: '.', decimal: ',', precision: 1 }">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                                </mat-hint>
                                <mat-hint align="end">{{txtQuebradasSeveras.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.quebradas_severas_g)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md">
                            <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Ardidas Leves (g)</mat-label>
                                <input matInput id="txtArdidasLeves" #txtArdidasLeves maxlength="10"
                                    formControlName="ardidas_g" currencyMask (blur)="makeCalculations()"
                                    [options]="{ thousands: '.', decimal: ',', precision: 1 }">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                                </mat-hint>
                                <mat-hint align="end">{{txtArdidasLeves.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.ardidas_g)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md">
                            <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Ardidas Severas (g)</mat-label>
                                <input matInput id="txtArdidasSeveras" #txtArdidasSeveras maxlength="10"
                                    formControlName="ardidas_severas_g" currencyMask (blur)="makeCalculations()"
                                    [options]="{ thousands: '.', decimal: ',', precision: 1 }">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                                </mat-hint>
                                <mat-hint align="end">{{txtArdidasSeveras.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.ardidas_severas_g)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-md">
                            <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Furadas Leves (g)</mat-label>
                                <input matInput id="txtFurLeves" #txtFurLeves maxlength="10"
                                    formControlName="furadas_leves_g" currencyMask (blur)="makeCalculations()"
                                    [options]="{ thousands: '.', decimal: ',', precision: 1 }">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                                </mat-hint>
                                <mat-hint align="end">{{txtFurLeves.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.furadas_leves_g)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md">
                            <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Furadas Severas (g)</mat-label>
                                <input matInput id="txtFurSeveras" #txtFurSeveras maxlength="10"
                                    formControlName="furadas_severas_g" currencyMask (blur)="makeCalculations()"
                                    [options]="{ thousands: '.', decimal: ',', precision: 1 }">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                                </mat-hint>
                                <mat-hint align="end">{{txtFurSeveras.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.furadas_severas_g)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-md">
                            <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Popped Kernel Leves (g)</mat-label>
                                <input matInput id="txtPopped" #txtPopped maxlength="10"
                                    formControlName="popped_kernel_g" currencyMask (blur)="makeCalculations()"
                                    [options]="{ thousands: '.', decimal: ',', precision: 1 }">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                                </mat-hint>
                                <mat-hint align="end">{{txtPopped.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.popped_kernel_g)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md">
                            <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Popped Kernel Severas (g)</mat-label>
                                <input matInput id="txtPoppedSeveras" #txtPoppedSeveras maxlength="10"
                                    formControlName="popped_kernel_severas_g" currencyMask (blur)="makeCalculations()"
                                    [options]="{ thousands: '.', decimal: ',', precision: 1 }">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                                </mat-hint>
                                <mat-hint align="end">{{txtPoppedSeveras.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.popped_kernel_severas_g)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md">
                            <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Inerte (g)</mat-label>
                                <input matInput id="txtInerte" #txtInerte maxlength="10" formControlName="inerte_g"
                                    currencyMask (blur)="makeCalculations()"
                                    [options]="{ thousands: '.', decimal: ',', precision: 1 }">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                                </mat-hint>
                                <mat-hint align="end">{{txtInerte.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.inerte_g)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md">
                            <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Presença de Sabugo ou Pedúnculo</mat-label>
                                <mat-select #txtPreSabPed formControlName="presenca_sabugo_ou_pedunculo"
                                    disableCenteringOption>
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterPreSabPed($event.target.value)">
                                    <mat-option *ngFor="let item of listPreSabPed" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.presenca_sabugo_ou_pedunculo)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-md">
                            <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Presença de Outras Sementes (Espécies)</mat-label>
                                <mat-select #txtPreOutSem formControlName="presenca_outras_sementes_especies"
                                    disableCenteringOption>
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterPreSem($event.target.value)">
                                    <mat-option *ngFor="let item of listPreSem" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-error>
                                    {{hasErrorFormControl(formulario.controls.presenca_outras_sementes_especies)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md">
                            <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Total Defeitos (g)</mat-label>
                                <input matInput id="txtDef" #txtDef maxlength="10" formControlName="total_defeitos_prc"
                                    currencyMask readonly class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}
                                </mat-hint>
                                <mat-hint align="end">{{txtDef.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.total_defeitos_prc)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md">
                            <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Total Defeitos Leves(g)</mat-label>
                                <input matInput id="txtDef" #txtDef maxlength="10"
                                    formControlName="total_defeitos_leves_prc" currencyMask readonly
                                    class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}
                                </mat-hint>
                                <mat-hint align="end">{{txtDef.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.total_defeitos_leves_prc)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md">
                            <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Total Defeitos Severos(g)</mat-label>
                                <input matInput id="txtDef" #txtDef maxlength="10"
                                    formControlName="total_defeitos_severos_prc" currencyMask readonly
                                    class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}
                                </mat-hint>
                                <mat-hint align="end">{{txtDef.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.total_defeitos_severos_prc)}}
                                </mat-error>
                            </mat-form-field>
                          </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-md">
                            <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Resultado Descriminado - Caso Reprovado</mat-label>
                                <input matInput id="txtResDescr" #txtResDescr maxlength="500"
                                    formControlName="resultado_descriminado_caso_reprovado" readonly
                                    class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}
                                </mat-hint>
                                <mat-hint align="end">{{txtResDescr.value.length}} / 500</mat-hint>
                                <mat-error>
                                    {{hasErrorFormControl(formulario.controls.resultado_descriminado_caso_reprovado)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md">
                            <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Resultado</mat-label>
                                <input matInput id="txtRes" #txtRes maxlength="3" formControlName="resultado" readonly
                                    [ngStyle]="{'background-color': formulario.controls.resultado.value === 'APR' ? 'green' : (formulario.controls.resultado.value === 'REP' ? 'red' : 'yellow')}">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}
                                </mat-hint>
                                <mat-hint align="end">{{txtRes.value.length}} / 3</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.resultado)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                </mat-card-content>
            </form>
        </mat-card>
    </div>
</div>
